import { render } from "./Page13.vue?vue&type=template&id=3af7e82e"
import script from "./Page13.vue?vue&type=script&lang=js"
export * from "./Page13.vue?vue&type=script&lang=js"

import "./Page13.vue?vue&type=style&index=0&id=3af7e82e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__